import { FC, Fragment, ReactNode, useContext } from "react";
import { USER_TYPES } from "../enums/user";
import { AuthContext, IAuthContext } from "../providers/authProvider";

export const ShowByRole: FC<{
  roles: (keyof IAuthContext)[];
  children: ReactNode;
}> = ({ roles, children }) => {
  const authContext = useContext(AuthContext);
  const show = roles.some((role) => authContext[role]);
  if (show) {
    return <>{children}</>;
  }
  return <Fragment />;
};
